import React from 'react';
import './a5_print_style.scss';
import companyLogo from 'assets/img/images/print_logo.png';
import Barcode from 'react-barcode';
import moment from 'moment';
import { moneyDecimalFormatter, customRound } from 'utli';

class A5CNPrintComponent extends React.Component {
  render() {
    const { data } = this.props;

    if (!data) return null;

    return (
      <div className={'Finance-Print'} style={{ fontFamily: 'SimSun, "Microsoft YaHei", Arial, sans-serif' }}>
        <div className={'Container'}>
          <div className={'LeftContainer'}>
            {/** Left Side */}
            <div className={'ContainerHeader'}>
              <div className={'Container'}>
                {/** Logo and Barcode */}
                <div className={'LogoContainer'}>
                  <img className={'Logo'} src={companyLogo} alt='Company Logo' style={{ width: 240, height: 80 }} />
                </div>
                <div className='BarCodeContainer'>
                  <h2>INVOICE</h2>
                  <Barcode
                    fontOptions='bolder'
                    value={data?.invoice_number}
                    width={2}
                    height={50}
                    fontSize={34}
                    margin={3}
                  />
                </div>
              </div>

              <div className='CodesContainer'>
                <h4>Customer code: {data.address_code}</h4>
                <h4>Salesperson code: {data.sale_person?.name}</h4>
              </div>
            </div>
            <div className={'ContainerItem'}>
              <div className={'Container'}>
                {/**container */}
                <h4 className={'Header'}>
                  {/**header */}
                  托运人信息
                </h4>
                <h4 className={'Header'}>
                  {/**header */}
                  收货人信息
                </h4>
              </div>
              {/* <div className={'Divider'} /> */}
              <div className={'Container'}>
                {/**container */}
                <div className={'Item'}>
                  <p>{data?.sender?.company}</p>
                  <p>{data?.sender?.name}</p>
                  <p>{data?.sender?.phone}</p>
                  <p>{data?.sender?.address}</p>
                </div>
                <div className={'Item'}>
                  <p>{data?.receiver?.company}</p>
                  <p>{data?.receiver?.name}</p>
                  <p>{data?.receiver?.phone}</p>
                  <p>{data?.receiver?.address}</p>
                </div>
              </div>
            </div>
            <div className={'ContainerItem'}>
              <div className={'Container'}>
                {/**container */}
                <h4 className={'Header'}>
                  {/**header */}
                  基本信息
                </h4>
              </div>
              {/* <div className={'Divider'} /> */}
              <div className={'Container'}>
                {/**container */}
                <div className={'Item'}>
                  <p>发票日期: {moment(Date.parse(data?.invoice_date)).format('DD-MM-YYYY')}</p>
                  <p>参考号: {data?.ref_no || '-'}</p>
                  <p>许可证号: {data?.license_no || '-'}</p>
                  <p>运单号: {data?.waybill_no || '-'}</p>
                </div>
                <div className={'Item'}>
                  <p>目的网点: {data?.destination?.name}</p>
                  <p>付款方式: {data?.paymentType?.name}</p>
                  <p>押金发票: {data?.deposit_invoice?.invoice_number || '-'}</p>
                </div>
              </div>
            </div>
            <div className={'ContainerItem'}>
              <div className={'Container'}>
                {/**container */}
                <h4 className={'Header'}>
                  {/**header */}
                  物品信息
                </h4>
              </div>
              {/* <div className={'Divider'} /> */}
              <div className={'Container'}>
                {/**container */}
                <div className={'Item'} style={{ width: '100%' }}>
                  {data?.items?.map((item, index) => (
                    <p key={index}>
                      {index + 1}. {item.itemname} ({item.qty} {item.unit}) - {moneyDecimalFormatter(item.amount)}
                    </p>
                  ))}
                </div>
              </div>
            </div>
            <div className={'ContainerItem'}>
              <div className={'Container'}>
                {/**container */}
                <h4 className={'Item'}>
                  {/**header */}
                  费用信息
                </h4>
                <h4 className={'Item'}>Payment method: {data?.paymentType?.name}</h4>
              </div>
              <div className={'Divider'} />
            </div>
            <div className={'FooterContainer'}>
              <div>
                <h4>总费 ({data?.currency})</h4>
                <h4>其他服务费</h4>
                <h4>已付金额</h4>
                <h4>保持平衡</h4>
              </div>
              <div className={'DividerRow'}>
                <h4>:</h4>
                <h4>:</h4>
                <h4>:</h4>
                <h4>:</h4>
              </div>
              <div>
                <h4>{moneyDecimalFormatter(customRound(data?.total_amount?.toFixed(2)))}</h4>
                <h4>{moneyDecimalFormatter(customRound(data?.other_service_charges?.toFixed(2)))}</h4>
                <h4>{moneyDecimalFormatter(customRound(data?.received_amount?.toFixed(2)))}</h4>
                <h4>{moneyDecimalFormatter(customRound(data?.remaining_balance?.toFixed(2)))}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default A5CNPrintComponent;
